<template>
  <div class="form-group">
    <div>
      <label class="inline-block uppercase text-[14px] tracking-[0.42px] font-bold mt-4 mb-2" for="waitinglisttype">Marknadsplats</label>
      <SelectField
        label=""
        placeholder="Välj marknadsplats"
        :floatingLabel="false"
        :options="availableWaitingListTypes"
        v-model="value__"
        @update:modelValue="change"
        size="md"
        @input="change($event)"
      />
    </div>
  </div>
</template>
<script>
import SelectField from '@/components/ui/form/select';
import { mapGetters } from 'vuex';
import { forEach, map } from 'lodash';
import { RENTALOBJECT_TYPES } from '@/config/constants';

export default {
  components: { SelectField },
  props: {
    value: {
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * Inskickat prop får inte manipuleras.
       * Den får sitt värde i watchen längre ner.
       */
      value__: [],
    };
  },
  computed: {
    /**
     * Alternativ att välja bland
     */
    availableWaitingListTypes() {
      if (this.type == RENTALOBJECT_TYPES.PARKING)
        return this.$store.getters.config.parkingsWaitingListTypes;
      if (this.type == RENTALOBJECT_TYPES.PREMISE)
        return this.$store.getters.config.premisesWaitingListTypes;
    },
  },
  watch: {
    /**
     * När v-model ändras, ska även det interna värdet ändras.
     * Detta sker t.ex. när man klickar på "Rensa"-knappen
     *
     * I fallet med denna, som använder Multiselect, är det lite special för att det ska funka.
     */
    value: {
      handler() {
        if (!this.value || (this.value && this.value.length == 0)) {
          this.value__ = [];
        } else {
          /**
           * När component skapas, kan v-model vara typ ["LGH1"].
           * Men internt behandlas varje objectType som ett object.
           * Därför måste en mappning ske vid start för att förvalda värden ska finnas
           */
          this.value__ = [];
          forEach(this.availableWaitingListTypes, (obj) => {
            if (this.value.indexOf(obj.code) > -1) {
              this.value__.push(obj);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    change() {
      this.$emit(
        'input',
        map(this.value__, (waitingListType) => {
          return waitingListType.code;
        }),
      );
    },
  },
};
</script>
